import { render, staticRenderFns } from "./HistoricChart.vue?vue&type=template&id=0d16b03e&"
import script from "./HistoricChart.vue?vue&type=script&lang=js&"
export * from "./HistoricChart.vue?vue&type=script&lang=js&"
import style0 from "./HistoricChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports